import { updateUserSetting } from "../../pages/LoginPage/reducer";
import { api } from "../api/callApi";
import { urlServer } from "../api/v1";
import { getDispatch, getStore } from "../store/store";
import { TREATMENT_TYPE } from "../varibles/constants";
import { FleetUtilizationItem, ICombineTreatment, IDensityMap, IVessel } from "../varibles/interface";

const urlBase = urlServer + '/vessel';

// getVesselData: (vesselId: string) => api.get(urlBase + '/data/' + vesselId),

interface IGetVesselSchedule {
    id: string,
    start_time: number,
    finish_time: number
}

export const VesselService = {
    vesselsByTenantId: (abort?: AbortController) => {
        const state = getStore();
        const { tenant_id } = state.login?.user || {};

        const callback = (rs: IVessel[]) => {
            if (rs.length > 0) {
                const { default_vessel } = state.login?.user || {};
                const { id = null } = rs.find((item: any) => item.id === default_vessel) || {};
                if (!id) {
                    getDispatch()(updateUserSetting([{}, rs[0].id]))
                }
            }
            return rs
        }

        return api.get<IVessel[]>(urlBase + '?tenant_id=' + tenant_id, { signal: abort?.signal, callback })
    },
    gets: () => api.get<IVessel[]>(urlBase),
    getByContracts: () => api.get<IVessel[]>(urlBase + '/contract'),
    getOperationByVessel: (vesselId: string) => api.get<any>(urlBase + '/' + vesselId),
    getPositions: (iotNames: string[]) => api.post<any[]>(urlBase + '/ioT', iotNames),
    getSchedule: (params: IGetVesselSchedule) => api.post<any>(urlBase + '/activity_log', params),
    add: (vessel: any) => {
        return api.post<IVessel>(urlBase, vessel)
    },
    update: (vessel: any) => {
        return api.put<IVessel>(urlBase, vessel)
    },
    equipments: () => {
        return api.post<any[]>(urlBase + '/equipments')
    },
    storages: () => {
        return api.post<any[]>(urlBase + '/storages')
    },
    combineTreatment: (vesselId: string) => {
        return api.post<ICombineTreatment[]>(urlBase + '/treatment-type/group', { vessel_id: vesselId })
    },
    getTreatmentTypes: (vesselId: string) => {
        return api.post<{ groups: ICombineTreatment[], elements: TREATMENT_TYPE[] }>(urlBase + '/treatment-type/groups', { vessel_id: vesselId })
    },
    density: (value: IDensityMap, vesselId: string) => {
        return api.put(urlBase + '/density', { id: vesselId, density_map: value })
    },
    summary: (body: { vessel_ids: string[]; start_time: number; finish_time: number; }) => {
        return api.post<FleetUtilizationItem[]>(urlBase + '/summary', body)
    },
    billingConfig: (body: { vessel_id: string, start_point?: IVessel['start_point'], hourly_cost?: IVessel['hourly_cost'], cleaning_agent?: IVessel['cleaning_agent'] }) => {
        return api.post(urlBase + '/billing', body)
    }
}
